export default __webpack_public_path__ + "static/media/TictacToeGame.63d3cd64.png";